import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { formatINR } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart } = useStore();
  const off = product.mrp ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.06 }}
      className="group relative border border-white/10 bg-[#0f0f0f] hover:border-white/30 transition-colors"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-[#161616]">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-100 transition-all duration-700"
          />
          {off > 0 && (
            <span className="absolute top-3 left-3 bg-[#E31E24] text-black text-[10px] font-bold px-2 py-1 uppercase tracking-wider">
              -{off}%
            </span>
          )}
          {product.stock <= 0 && (
            <span className="absolute top-3 right-3 bg-[#E63946] text-white text-[10px] font-bold px-2 py-1 uppercase tracking-wider">
              Out of stock
            </span>
          )}
        </div>
      </Link>
      <div className="p-5">
        <p className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-2">{product.brand}</p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-display font-bold text-base leading-tight mb-4 min-h-[2.5rem] group-hover:text-[#E31E24] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-end justify-between">
          <div>
            <p className="font-display font-black text-xl">{formatINR(product.price)}</p>
            {product.mrp && product.mrp > product.price && <p className="text-white/40 text-xs line-through">{formatINR(product.mrp)}</p>}
          </div>
          <button
            data-testid={`add-cart-${product.slug}`}
            disabled={product.stock <= 0}
            onClick={(e) => { e.preventDefault(); addToCart(product); }}
            className="btn-fill w-10 h-10 grid place-items-center border border-white/20 text-white hover:text-black disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            aria-label="Add to cart"
          >
            <ArrowUpRight size={18} />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
